import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatMessage } from 'i18n/CurrentLocale';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as validation from 'myParkdUtils/validationHandling';
import * as feedbackActions from 'features/support/feedbackActions';
import ErrorMessage from 'components/ErrorMessage';
import SubmitButton from 'components/SubmitButton';

const SendFeedbackToSupportModal = props => {
    const [message, setMessage] = useState('');
    const [showValidationErrors, setShowValidationErrors] = useState(false);

    function getValidationErrors() {
        let errors = {};
        errors.feedback = validation.checkIfNotNull(message);
        return errors;
    }

    function handleSubmit(e) {
        e.preventDefault();
        const validationSuccessful = validation.validate(getValidationErrors());
        if (validationSuccessful) {
            props.sendFeedbackToSupport({
                message: message,
                starRatingData: props.starRatingData
            });
        } else {
            setShowValidationErrors(true);
        }
    }

    const errors = getValidationErrors();
    const validationSuccessful = validation.validate(errors);

    return (
        <div id="send-feedback-modal" className="panel radius-rectangle">
            <div className="panel-header center">
                <h2 className="bold-title">
                    <React.Fragment>
                        <FontAwesomeIcon icon={faCommentDots} />
                        <FormattedMessage id="SEND_FEEDBACK_TO_SUPPORT_MODAL_TITLE" />
                    </React.Fragment>
                </h2>
                <button className="btn-close-modal" onClick={props.closeModal} />
            </div>
            <div className="panel-content full-width-form">
                <form
                    onSubmit={handleSubmit}
                    noValidate
                    className={
                        (validationSuccessful ? 'validation-successful ' : '') +
                        (showValidationErrors ? 'show-validation-messages' : 'hide-validation-messages')
                    }
                >
                    <textarea
                        className={'text-field dark-placeholder ' + (errors.feedback ? 'error' : 'valid')}
                        rows="6"
                        placeholder={formatMessage({ id: 'PLACEHOLDER_SEND_TO_SUPPORT_FEEDBACK' })}
                        autoFocus
                        onChange={e => setMessage(e.target.value)}
                    />

                    <ErrorMessage msg={errors.feedback} />

                    <SubmitButton buttonText={formatMessage({ id: 'GLOBAL_SEND' })} saving={props.feedbackStatus.isSending} />
                </form>
            </div>
        </div>
    );
};

function mapStateToProps(state, props) {
    return {
        feedbackStatus: state.feedback.feedbackStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateModal: modalWindowActions.updateModalWindow,
            sendFeedbackToSupport: feedbackActions.sendFeedbackToSupport
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(SendFeedbackToSupportModal);
